import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";
import { useForm } from "react-hook-form";
import Card from "react-bootstrap/Card";
import IconAdd from "../../../Assets/Img/icon_add_c.svg";
import api from "../../../utils/axios";

import {
	ArrowLeftIcon,
	CheckIcon,
	ChevronDownIcon,
	ChevronRightIcon,
} from "@heroicons/react/24/outline";

import AnimacionSuccessful from "../../AnimacionSuccessful/animacionSuccessful";
import { Button, CloseButton, InputGroup } from "react-bootstrap";
import "../Laboratories.css";
import Switch from "../../Switch";
export default function LabsForm(props) {
	const navigate = useNavigate();

	const [name, setName] = useState("");
	const [officeNumber, setOfficeNumber] = useState("");
	const [address, setAddress] = useState("");
	const [productsAdded, setProductsAdded] = useState([]); // Productos elegidos para agregar
	const [otherProductsAdded, setOtherProductsAdded] = useState([]); // Otros productos agregados
	const [productTagsAdded, setProductTagsAdded] = useState([]); // Tags elegidos para agregar
	const [otherProductTagsAdded, setOtherProductTagsAdded] = useState([]); // Otros tags elegidos

	const [allProducts, setAllProducts] = useState([]);
	const [allProductsTags, setAllProductsTags] = useState([]);
	const [allOtherProducts, setAllOtherProducts] = useState([]);
	const [allOtherProductsTags, setAllOtherProductsTags] = useState([]);
	const [selectAllBioquimicos, setSelectAllBioquimicos] = useState(false);

	const [selectAllVarios, setSelectAllVarios] = useState(false);
	const [openBioGroupIds, setOpenBioGroupIds] = useState([]);
	const [openVariousGroupIds, setOpenVariousGroupIds] = useState([]);

	const [productInputValue, setProductInputValue] = useState(""); // Guarda el valor del input productos
	const [otherProductInputValue, setOtherProductInputValue] = useState(""); // Guarda el valor del input otros productos
	const [categoryInputValue, setCategoryInputValue] = useState(""); // Guarda el valor del input categorías
	const [searchValueAdded, setSearchValueAdded] = useState(""); // Valor del buscador para productos agregados

	const [allCategories, setAllCategories] = useState([]); // Categorías disponibles
	const [selectedCategories, setSelectedCategories] = useState([]); // Categorías seleccionadas
	const [showAllCategories, setShowAllCategories] = useState(false); // Mostrar todas las categorías
	const [enableCategorySelection, setEnableCategorySelection] = useState(false); // Habilitar selección de categorías
	const [showAddByCategory, setShowAddByCategory] = useState(false); // Estado para "Agregar por categoría"
	const [relatedProducts, setRelatedProducts] = useState([]);
	const [relatedTags, setRelatedTags] = useState([]);

	const [variable, setVariable] = useState(false);
	const [errorBool, setErrorBool] = useState(false);
	const [avisomsg, setAvisomsg] = useState("");
	const hasHydratedBioInitialSelection = useRef(false);
	const hasHydratedVariousInitialSelection = useRef(false);

	const {
		register,
		handleSubmit,
		setValue,
		formState: { errors },
	} = useForm();

	useEffect(() => {
		(async () => {
			setName(props?.name || "");
			setOfficeNumber(props?.officeNumber || "");
			setAddress(props?.address || "");
			setProductsAdded(props?.productsAdded || []);
			setOtherProductsAdded(props?.otherProductsAdded || []);
			setProductTagsAdded(props?.productTagsAdded || []);
			setOtherProductTagsAdded(props?.otherProductTagsAdded || []);
			if (props?.name) setValue("name", props.name);
			if (props?.officeNumber) setValue("officeNumber", props.officeNumber);
			if (props?.address) setValue("address", props.address);
		})();
	}, [props, setValue]);

	useEffect(() => {
		(async () => {
			try {
				const responseCategories = await api.get("/categories");

				setAllCategories(responseCategories.data.categories);

				const responseTags = await api.get("/tags");
				const tags = responseTags.data.tags || [];
				const globalTag = tags.find((tag) => tag.name === "-");

				setAllProducts(globalTag?.products || []);
				setAllOtherProducts(globalTag?.otherProducts || []);
				setAllProductsTags(tags.filter((tag) => tag.name !== "-" && tag.isProducts));
				setAllOtherProductsTags(tags.filter((tag) => tag.name !== "-" && tag.isProducts === false));
			} catch (error) {
				console.log(error);
			}
		})();
	}, []);

	// Agregar productos y tags relacionados cuando se seleccionan categorías
	useEffect(() => {
		// Filtrar productos relacionados
		const filteredProducts = allOtherProducts.filter((product) =>
			selectedCategories.some((category) => category._id === product.category._id)
		);

		setRelatedProducts(filteredProducts); // Actualizar los productos relacionados

		// Filtrar tags relacionados
		const filteredTags = allOtherProductsTags.filter((tag) =>
			selectedCategories.some((category) => category._id === tag.category || category._id === tag.category._id)
		);

		setRelatedTags(filteredTags); // Actualizar los tags relacionados
	}, [selectedCategories, allOtherProducts, allOtherProductsTags]); // Dependencia en selectedCategories, allOtherProducts y allOtherProductTags


	const onSubmit = async () => {
		try {
			if (!name || !officeNumber || !address) {
				alert("Completa todos los campos");
				return;
			}
			if (
				productsAdded.length === 0 &&
				otherProductsAdded.length === 0 &&
				productTagsAdded.length === 0 &&
				otherProductTagsAdded.length === 0
			) {
				alert("Debe seleccionar al menos un producto o etiqueta");
				return;
			}

			if (props.type === "addLabs") {
				await api.post("/laboratory/add", {
					name: name,
					officeNumber: officeNumber,
					address: address,
					products: toIds(productsAdded),
					otherProducts: toIds(otherProductsAdded),
					tags: toIds([...productTagsAdded, ...otherProductTagsAdded]),
				});
				setAvisomsg("Laboratorio creado correctamente");
			} else if (props.type === "editLabs") {
				await api.post(`/laboratory/edit/${props.id}`, {
					name: name,
					officeNumber: officeNumber,
					address: address,
					products: toIds(productsAdded),
					otherProducts: toIds(otherProductsAdded),
					tags: toIds([...productTagsAdded, ...otherProductTagsAdded]),
				});
				setAvisomsg("Laboratorio editado correctamente");
			}
			setVariable(true);
			setErrorBool(false);
			setTimeout(() => {
				setVariable(false);
				navigate("/laboratory");
			}, 1200);
		} catch (error) {
			setErrorBool(true);
			setVariable(true);
			setTimeout(() => {
				setVariable(false);
				setAvisomsg(error.response.data.msg);
			}, 1200);
			console.log("Error al agregar el laboratorio:");
		}
	};


	// Filtrar productos y tags agregados para la búsqueda
	const filteredProductsAdded = productsAdded.filter((product) =>
		product.name.toLowerCase().includes(searchValueAdded.toLowerCase())
	);
	const filteredOtherProductsAdded = otherProductsAdded.filter((product) =>
		product.name.toLowerCase().includes(searchValueAdded.toLowerCase())
	);

	// Filtrar tags agregados para la búsqueda
	const filteredTagsAdded = otherProductTagsAdded.filter((tag) =>
		tag.name.toLowerCase().includes(searchValueAdded.toLowerCase())
	);

	// Eliminación de productos relacionados
	const handleDeleteRelatedProduct = (product) => {
		setRelatedProducts((prev) => prev.filter((p) => p._id !== product._id)); // Filtra y elimina el producto
	};

	// Eliminación de tags relacionados
	const handleDeleteRelatedTag = (tag) => {
		setRelatedTags((prev) => prev.filter((t) => t._id !== tag._id)); // Filtra y elimina el tag
	};

	//Seleccionar todos los productos bioquimicos y tags
	const getProductCode = (item) => {
		return item?.code || item?.codigo || item?.productCode || item?.sku || "";
	};

	const getProductName = (item) => {
		return item?.name || item?.description || item?.label || "";
	};

	const getProductId = (item) => {
		if (!item) return null;

		if (typeof item === "string") {
			return item;
		}

		return item._id || item.id || null;
	};

	// El backend espera ObjectIds; el formulario puede tener objetos completos o ids.
	const toIds = (items) =>
		items.map((item) => getProductId(item)).filter(Boolean);

	const sameId = (firstId, secondId) => {
		return String(firstId) === String(secondId);
	};

	const matchesProductSearch = (item, searchValue) => {
		const normalizedSearch = searchValue.trim().toLowerCase();

		if (!normalizedSearch) {
			return true;
		}

		const itemName = getProductName(item);
		const itemCode = getProductCode(item);

		return `${itemName} ${itemCode}`.toLowerCase().includes(normalizedSearch);
	};

	const getCategoryId = (product) => {
		if (!product?.category) return "without-category";

		if (typeof product.category === "string") {
			return product.category;
		}

		return product.category._id || product.category.id || "without-category";
	};

	const getCategoryName = (categoryId, product) => {
		if (product?.category && typeof product.category === "object" && product.category.name) {
			return product.category.name;
		}

		const category = allCategories.find((categoryItem) =>
			sameId(categoryItem._id, categoryId)
		);

		return category?.name || "Sin categoría";
	};

	const getUniqueProducts = (products) => {
		const productsById = new Map();

		products.forEach((product) => {
			const productId = getProductId(product);

			if (productId) {
				productsById.set(String(productId), product);
			}
		});

		return Array.from(productsById.values());
	};

	const hydrateSelectedProducts = (initialProducts = [], availableProducts = []) => {
		const initialIds = toIds(initialProducts);

		if (!initialIds.length) {
			return [];
		}

		const availableProductsById = new Map(
			availableProducts.map((product) => [String(getProductId(product)), product])
		);

		return getUniqueProducts(
			initialIds
				.map((productId) => {
					const normalizedId = String(productId);

					return (
						availableProductsById.get(normalizedId) ||
						initialProducts.find((product) =>
							sameId(getProductId(product), normalizedId)
						)
					);
				})
				.filter(Boolean)
		);
	};

	const bioGroups = [
		...allProductsTags.map((tag) => ({
			id: `bio-tag-${tag._id}`,
			name: tag.name || "Etiqueta sin nombre",
			type: "Etiqueta",
			products: tag.products || [],
			tag,
		})),
		{
			id: "bio-without-tag",
			name: "Sin etiqueta",
			type: "Productos sin etiqueta",
			products: allProducts || [],
			tag: null,
		},
	].filter((group) => group.products.length > 0);

	const otherProductsByCategory = (allOtherProducts || []).reduce((groups, product) => {
		const categoryId = getCategoryId(product);

		if (!groups[categoryId]) {
			groups[categoryId] = {
				id: `various-category-${categoryId}`,
				name: getCategoryName(categoryId, product),
				type: categoryId === "without-category" ? "Productos sin categoría" : "Categoría",
				products: [],
				tag: null,
			};
		}

		groups[categoryId].products.push(product);
		return groups;
	}, {});

	const variousGroups = [
		...Object.values(otherProductsByCategory),
		...allOtherProductsTags.map((tag) => ({
			id: `various-tag-${tag._id}`,
			name: tag.name || "Etiqueta sin nombre",
			type: "Etiqueta",
			products: tag.otherProducts || tag.products || [],
			tag,
		})),
	].filter((group) => group.products.length > 0);

	const filteredBioGroups = bioGroups
		.map((group) => ({
			...group,
			products: group.products.filter((product) =>
				matchesProductSearch(product, productInputValue)
			),
		}))
		.filter((group) => group.products.length > 0);

	const filteredVariousGroups = variousGroups
		.map((group) => ({
			...group,
			products: group.products.filter((product) =>
				matchesProductSearch(product, otherProductInputValue)
			),
		}))
		.filter((group) => group.products.length > 0);

	const isBioProductSelected = (product) => {
		return productsAdded.some((productAdded) =>
			sameId(getProductId(productAdded), getProductId(product))
		);
	};

	const isOtherProductSelected = (product) => {
		return otherProductsAdded.some((productAdded) =>
			sameId(getProductId(productAdded), getProductId(product))
		);
	};

	const isBioTagSelected = (tag) => {
		return productTagsAdded.some((addedTag) =>
			sameId(getProductId(addedTag), getProductId(tag))
		);
	};

	const isOtherTagSelected = (tag) => {
		return otherProductTagsAdded.some((addedTag) =>
			sameId(getProductId(addedTag), getProductId(tag))
		);
	};

	const toggleBioTag = (tag) => {
		const tagId = getProductId(tag);

		if (!tagId) return;

		setProductTagsAdded((prev) =>
			prev.some((prevTag) => sameId(getProductId(prevTag), tagId))
				? prev.filter((prevTag) => !sameId(getProductId(prevTag), tagId))
				: [...prev, tag]
		);
	};

	const toggleOtherTag = (tag) => {
		const tagId = getProductId(tag);

		if (!tagId) return;

		setOtherProductTagsAdded((prev) =>
			prev.some((prevTag) => sameId(getProductId(prevTag), tagId))
				? prev.filter((prevTag) => !sameId(getProductId(prevTag), tagId))
				: [...prev, tag]
		);
	};

	const toggleBioProduct = (product) => {
		const productId = getProductId(product);

		if (productsAdded.some((productAdded) => sameId(getProductId(productAdded), productId))) {
			setProductsAdded((prev) =>
				prev.filter((prevProduct) => !sameId(getProductId(prevProduct), productId))
			);
			return;
		}

		setProductsAdded((prev) => getUniqueProducts([...prev, product]));
	};

	const toggleOtherProduct = (product) => {
		const productId = getProductId(product);

		if (otherProductsAdded.some((productAdded) => sameId(getProductId(productAdded), productId))) {
			setOtherProductsAdded((prev) =>
				prev.filter((prevProduct) => !sameId(getProductId(prevProduct), productId))
			);
			return;
		}

		setOtherProductsAdded((prev) => getUniqueProducts([...prev, product]));
	};

	const getSelectedBioCount = (products) => {
		return products.filter((product) => isBioProductSelected(product)).length;
	};

	const getSelectedOtherCount = (products) => {
		return products.filter((product) => isOtherProductSelected(product)).length;
	};

	const allBioProducts = getUniqueProducts(
		bioGroups.flatMap((group) => group.products)
	);

	const allVariousProducts = getUniqueProducts(
		variousGroups.flatMap((group) => group.products)
	);

	const isEditHydrationReady =
		props?.type !== "editLabs" ||
		Boolean(props?.name || props?.address || props?.officeNumber);

	useEffect(() => {
		if (props?.type !== "editLabs") {
			hasHydratedBioInitialSelection.current = true;
			return;
		}

		if (!isEditHydrationReady || hasHydratedBioInitialSelection.current) {
			return;
		}

		const initialBioProducts = props?.productsAdded || [];

		if (!initialBioProducts.length) {
			hasHydratedBioInitialSelection.current = true;
			return;
		}

		if (!allBioProducts.length) {
			return;
		}

		setProductsAdded(hydrateSelectedProducts(initialBioProducts, allBioProducts));
		hasHydratedBioInitialSelection.current = true;
	}, [allBioProducts, isEditHydrationReady, props?.productsAdded, props?.type]);

	useEffect(() => {
		if (props?.type !== "editLabs") {
			hasHydratedVariousInitialSelection.current = true;
			return;
		}

		if (!isEditHydrationReady || hasHydratedVariousInitialSelection.current) {
			return;
		}

		const initialVariousProducts = props?.otherProductsAdded || [];

		if (!initialVariousProducts.length) {
			hasHydratedVariousInitialSelection.current = true;
			return;
		}

		if (!allVariousProducts.length) {
			return;
		}

		setOtherProductsAdded(
			hydrateSelectedProducts(initialVariousProducts, allVariousProducts)
		);
		hasHydratedVariousInitialSelection.current = true;
	}, [allVariousProducts, isEditHydrationReady, props?.otherProductsAdded, props?.type]);

	const selectedBioProductsCount = allBioProducts.filter((product) =>
		isBioProductSelected(product)
	).length;

	const selectedVariousProductsCount = allVariousProducts.filter((product) =>
		isOtherProductSelected(product)
	).length;

	const allBioSelected =
		allBioProducts.length > 0 && selectedBioProductsCount === allBioProducts.length;

	const allVariousSelected =
		allVariousProducts.length > 0 && selectedVariousProductsCount === allVariousProducts.length;

	const handleSelectAllBioquimicos = (checked) => {
		if (checked) {
			setProductsAdded(allBioProducts);
			setProductTagsAdded([]);
		} else {
			setProductsAdded((prev) =>
				prev.filter(
					(product) =>
						!allBioProducts.some((bioProduct) =>
							sameId(getProductId(bioProduct), getProductId(product))
						)
				)
			);
			setProductTagsAdded([]);
		}

		setSelectAllBioquimicos(checked);
	};

	const handleSelectAllVarios = (checked) => {
		if (checked) {
			setOtherProductsAdded(allVariousProducts);
			setOtherProductTagsAdded([]);
		} else {
			setOtherProductsAdded((prev) =>
				prev.filter(
					(product) =>
						!allVariousProducts.some((variousProduct) =>
							sameId(getProductId(variousProduct), getProductId(product))
						)
				)
			);
			setOtherProductTagsAdded([]);
		}

		setSelectAllVarios(checked);
	};

	const toggleBioGroup = (groupId) => {
		setOpenBioGroupIds((prev) => {
			if (prev.includes(groupId)) {
				return prev.filter((id) => id !== groupId);
			}

			return [...prev, groupId];
		});
	};

	const toggleVariousGroup = (groupId) => {
		setOpenVariousGroupIds((prev) => {
			if (prev.includes(groupId)) {
				return prev.filter((id) => id !== groupId);
			}

			return [...prev, groupId];
		});
	};


	return (
		<div className="main-container lab-form-page">
			<div className="lab-form-topbar">
				<button
					type="button"
					className="lab-form-back-button"
					onClick={() => navigate("/laboratory")}
				>
					<ArrowLeftIcon className="lab-form-back-icon" />
					<span>Volver a lista</span>
				</button>

				<h1 className="lab-form-page-title">
					{props.type === "addLabs" ? "Agregar Laboratorio" : "Editar Laboratorio"}
				</h1>
			</div>

			<Form className="lab-form" onSubmit={handleSubmit(onSubmit)}>
				<section className="lab-form-card">
					<h2 className="lab-form-section-title">Datos Principales</h2>

					<div className="lab-form-divider tw-mb-5" />

					<div className="lab-form-grid">
						<div className="lab-form-field">
							<label>Nombre del Laboratorio</label>
							<Form.Control
								className="lab-form-input"
								placeholder="Ej: Laboratorio Central"
								value={name}
								type="text"
								{...register("name", {
									required: "Este campo es requerido",
								})}
								onChange={(e) => setName(e.target.value)}
							/>
							{errors.name && <span className="error">{errors.name.message}</span>}
						</div>

						<div className="lab-form-field">
							<label>Número de Sede</label>
							<Form.Control
								className="lab-form-input"
								placeholder="Ej: 001"
								value={officeNumber}
								type="number"
								min="1"
								{...register("officeNumber", {
									required: "Este campo es requerido",
								})}
								onChange={(e) => setOfficeNumber(e.target.value)}
							/>
							{errors.officeNumber && <span className="error">{errors.officeNumber.message}</span>}
						</div>

						<div className="lab-form-field lab-form-field-full">
							<label>Dirección</label>
							<Form.Control
								className="lab-form-input"
								placeholder="Ej: Av. Principal 123, Ciudad"
								value={address}
								type="text"
								{...register("address", {
									required: "Este campo es requerido",
								})}
								onChange={(e) => setAddress(e.target.value)}
							/>
							{errors.address && <span className="error">{errors.address.message}</span>}
						</div>
					</div>
					<div className="lab-form-divider" />
					<div className="lab-form-section-spacer" />

					<h2 className="lab-form-section-title">Asignación de Productos</h2>



					<p className="lab-form-description">
						Explora las categorías y selecciona los productos que necesita este laboratorio
					</p>

					<div className="lab-products-section">
						<div className="lab-products-header">
							<div>
								<div className="lab-products-category-title">Productos Bioquímicos</div>
								<p>Seleccionados: {selectedBioProductsCount}</p>
								<p className="lab-products-helper">
									Habilitá etiquetas para pedidos de usuarios sede.
								</p>
							</div>

							<Form.Check
								type="checkbox"
								label="Seleccionar todos"
								checked={allBioSelected || selectAllBioquimicos}
								onChange={(e) => handleSelectAllBioquimicos(e.target.checked)}
								className="lab-select-all-check"
							/>
						</div>

						<Form.Control
							className="lab-form-input lab-products-search"
							placeholder="Buscar por nombre o código..."
							type="text"
							value={productInputValue}
							onChange={(e) => setProductInputValue(e.target.value)}
						/>

						<div className="lab-products-list lab-products-list-scroll">
							{filteredBioGroups.length > 0 ? (
								filteredBioGroups.map((group) => {
									const isOpen = openBioGroupIds.includes(group.id);
									const selectedCount = getSelectedBioCount(group.products);
									const tagSelected = group.tag ? isBioTagSelected(group.tag) : false;
									const isTagToggleDisabled = !group.tag;

									return (
										<div className="lab-product-group" key={group.id}>
											<div className="lab-product-group-header">
												<button
													type="button"
													className="lab-product-group-toggle"
													onClick={() => toggleBioGroup(group.id)}
												>
													<div className="lab-product-group-title">
														{isOpen ? (
															<ChevronDownIcon className="lab-product-group-icon" />
														) : (
															<ChevronRightIcon className="lab-product-group-icon" />
														)}

														<div>
															<span>{group.name}</span>
															<small>({group.products.length})</small>
														</div>
													</div>
												</button>

												<div className="lab-product-group-actions">
													{selectedCount > 0 ? (
														<span className="lab-products-selected-badge">
															{selectedCount} seleccionados
														</span>
													) : null}

													<Switch
														checked={tagSelected}
														disabled={isTagToggleDisabled}
														tooltip={
															isTagToggleDisabled
																? "Solo disponible para etiquetas"
																: "Habilitar etiqueta"
														}
														onChange={() => toggleBioTag(group.tag)}
													/>
												</div>
											</div>

											{isOpen ? (
												<div>
													{group.products.map((product) => {
														const selected = isBioProductSelected(product);
														const productCode = getProductCode(product);

														return (
															<button
																type="button"
																className={`lab-products-row lab-products-selectable-row ${selected ? "lab-products-row-selected" : ""
																	}`}
																key={getProductId(product) || product.name}
																onClick={() => toggleBioProduct(product)}
															>
																<div className="lab-products-row-content">
																	<div>
																		<span>{getProductName(product)}</span>

																		{productCode ? (
																			<p>Código: {productCode}</p>
																		) : null}
																	</div>

																	{selected ? (
																		<CheckIcon className="lab-products-check-icon" />
																	) : null}
																</div>
															</button>
														);
													})}
												</div>
											) : null}
										</div>
									);
								})
							) : (
								<div className="lab-products-empty">
									No se encontraron productos bioquímicos
								</div>
							)}
						</div>
					</div>

					<div className="lab-products-section">
						<div className="lab-products-header">
							<div>
								<div className="lab-products-category-title">Productos Varios</div>
								<p>Seleccionados: {selectedVariousProductsCount}</p>
								<p className="lab-products-helper">
									Habilitá etiquetas para pedidos de sede.
								</p>
							</div>

							<Form.Check
								type="checkbox"
								label="Seleccionar todos"
								checked={allVariousSelected || selectAllVarios}
								onChange={(e) => handleSelectAllVarios(e.target.checked)}
								className="lab-select-all-check"
							/>
						</div>

						<Form.Control
							className="lab-form-input lab-products-search"
							placeholder="Buscar por nombre o código..."
							type="text"
							value={otherProductInputValue}
							onChange={(e) => setOtherProductInputValue(e.target.value)}
						/>

						<div className="lab-products-list lab-products-list-scroll">
							{filteredVariousGroups.length > 0 ? (
								filteredVariousGroups.map((group) => {
									const isOpen = openVariousGroupIds.includes(group.id);
									const selectedCount = getSelectedOtherCount(group.products);
									const tagSelected = group.tag ? isOtherTagSelected(group.tag) : false;
									const isTagToggleDisabled = !group.tag;

									return (
										<div className="lab-product-group" key={group.id}>
											<div className="lab-product-group-header">
												<button
													type="button"
													className="lab-product-group-toggle"
													onClick={() => toggleVariousGroup(group.id)}
												>
													<div className="lab-product-group-title">
														{isOpen ? (
															<ChevronDownIcon className="lab-product-group-icon" />
														) : (
															<ChevronRightIcon className="lab-product-group-icon" />
														)}

														<div>
															<span>{group.name}</span>
															<small>({group.products.length})</small>
														</div>
													</div>
												</button>

												<div className="lab-product-group-actions">
													{selectedCount > 0 ? (
														<span className="lab-products-selected-badge">
															{selectedCount} seleccionados
														</span>
													) : null}

													<Switch
														checked={tagSelected}
														disabled={isTagToggleDisabled}
														tooltip={
															isTagToggleDisabled
																? "Solo disponible para etiquetas"
																: "Habilitar etiqueta"
														}
														onChange={() => toggleOtherTag(group.tag)}
													/>
												</div>
											</div>

											{isOpen ? (
												<div>
													{group.products.map((product) => {
														const selected = isOtherProductSelected(product);
														const productCode = getProductCode(product);

														return (
															<button
																type="button"
																className={`lab-products-row lab-products-selectable-row ${selected ? "lab-products-row-selected" : ""
																	}`}
																key={getProductId(product) || product.name}
																onClick={() => toggleOtherProduct(product)}
															>
																<div className="lab-products-row-content">
																	<div>
																		<span>{getProductName(product)}</span>

																		{productCode ? (
																			<p>Código: {productCode}</p>
																		) : null}
																	</div>

																	{selected ? (
																		<CheckIcon className="lab-products-check-icon" />
																	) : null}
																</div>
															</button>
														);
													})}
												</div>
											) : null}
										</div>
									);
								})
							) : (
								<div className="lab-products-empty">
									No se encontraron productos varios
								</div>
							)}
						</div>
					</div>

					<div className="lab-products-total">
						<strong>Total de productos asignados:</strong>{" "}
						{selectedBioProductsCount + selectedVariousProductsCount}{" "}
						({selectedBioProductsCount} bioquímicos, {selectedVariousProductsCount} varios)
					</div>
				</section>

				<div className="lab-form-footer">
					<button
						type="button"
						className="lab-form-cancel-button"
						onClick={() => navigate("/laboratory")}
					>
						Cancelar
					</button>

					<button className="lab-form-save-button" type="submit">
						{props.type === "addLabs" ? "Guardar" : "Guardar Cambios"}
					</button>
				</div>
			</Form>

			{variable && (
				<AnimacionSuccessful
					variable={variable}
					setVariable={setVariable}
					setErrorBool={setErrorBool}
					avisomsg={avisomsg}
					errorBool={errorBool}
				/>
			)}
		</div>
	);
}
